(function ($, document, window, undefined) {

    $(document).ready(function() {

        window.Frontier.Galleries.init()

        if( $("[data-js=google-map]").length ) {
            window.Frontier.Maps.init()
        }

        /*
        $("select").each(function(e){
            $(this).selectric();
        });
        */
       

        if( $(".page-template-page-suites").length >= 1 ){
            window.Frontier.Suites.init();
        }

        if( $(".page-template-page-amenities").length >= 1 ){
            window.Frontier.Amenities.init();
        }

        if( $(".page-template-page-home").length >= 1 ) {
            modal = new window.Frontier.Modal()
        }

        window.Frontier.Global.init();

        $(document).keyup(function (e) {
            //console.log("key up")
            if (e.key === "Escape") { // escape key maps to keycode `27`
                $('.modal').fadeOut('600');
            }
        });

        $(document).on("focusin focusout", ".gfield input:not(.selectric-input), .gfield textarea", formHandler);

        $(document).on("click", "[data-js=menu-toggle]", mobileMenuHandler);
        $(document).on("keydown", "[data-js=menu-toggle]", mobileMenuHandler);        

        jQuery(document).on('gform_post_render', function(){
 
            $("select").each(function(e){
                $(this).selectric({
                    disableOnMobile: false,
                    nativeOnMobile: false
                });
            });

            var fields = document.querySelectorAll('.gfield');

            fields.forEach(function(field){
    
                var field_val = field.querySelector('input[type=text]');
                if(field_val){
                    field_val = field_val.value;
                }
                var field_label = field.querySelector('.gfield_label');
    
                
                console.log(field_val);
                console.log(typeof(field_val));
    
                if(field_val != ''){
                    field_label.style.display = 'none';
                }
    
            })            
     
        });

        $('.home .video-play-button').on('click',function() {
            $('#video').addClass('nowPlaying');
        })



       $(".register-button").click(function (e) {
        dataLayer.push({event: "contactButtonClick"});
       });
        
    })
        
    var menu_open = false;    
    function mobileMenuHandler(e) {

        //console.log(e);
        if(e.type === 'click' || e.key === 'Enter' || e.keyCode === 13){
            $(document).find(".menu-primary-container ul").slideToggle();
            $(document).find("[data-js=menu-toggle]").toggleClass("is-active");
            
            if(!menu_open){
                $(document).find("[data-js=menu-toggle]").attr('aria-expanded', 'true')
                $(document).find("[data-js=menu-toggle]").attr('aria-label', 'Close navigation menu')                
                menu_open = true
            } else {
                $(document).find("[data-js=menu-toggle]").attr('aria-expanded', 'false')
                $(document).find("[data-js=menu-toggle]").attr('aria-label', 'Open navigation menu')
                menu_open = false
            }
        }

    }

    function formHandler(e){
        var $parent = $(this).closest(".gfield");
	
        //console.log(e.type);
        //console.dir($parent);

        if(e.type == "focusin") 
            $parent.find(".gfield_label").hide();
            //$parent.css("outline", "1px solid red");
        else if( $(this).val().length == 0 )
            $parent.find(".gfield_label").show();
            //$parent.css("outline", "1px solid transparent");	
	
    }


   $(document).bind("gform_confirmation_loaded", function(event, formID) {
     window.dataLayer = window.dataLayer || [];
     dataLayer.push({event: "contactFormCompletion"});
   });



}(jQuery, document, window));
